import { responseError } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import withDraft from '@/utils/draftHelper';
import { findRequest } from '../../state/state';
import actions from '../constants';

const subscribeToRequestDataset = withDraft((draft, action) => {
  const { steps } = findRequest(draft, action);
  steps.subscriptionsStatus = states.PENDING;
});

const subscribeToRequestDatasetSuccess = withDraft((draft, action) => {
  const { steps } = findRequest(draft, action);
  steps.results[0].subscriptions = action.subscriptions;
  steps.subscriptionsStatus = states.SUCCESS;
  steps.subscriptionsErrors = [];
});

const subscribeToRequestDatasetError = withDraft((draft, action) => {
  const { steps } = findRequest(draft, action);
  steps.subscriptionsStatus = states.ERROR;
  steps.subscriptionsErrors = [responseError(action)];
});

const fetchRequestUserSubscriptions = withDraft((draft, action) => {
  const { steps } = findRequest(draft, action);
  steps.subscriptionsReadStatus = states.PENDING;
});

const fetchRequestUserSubscriptionsSuccess = withDraft((draft, action) => {
  const { steps } = findRequest(draft, action);
  steps.results[0].subscriptions = action.result;
  steps.subscriptionsReadStatus = states.SUCCESS;
  steps.subscriptionsReadErrors = [];
});

const fetchRequestUserSubscriptionsError = withDraft((draft, action) => {
  const { steps } = findRequest(draft, action);
  steps.subscriptionsReadStatus = states.ERROR;
  steps.subscriptionsReadErrors = [responseError(action)];
});

export default {
  [actions.FETCH_REQUEST_USER_SUBSCRIPTIONS]: fetchRequestUserSubscriptions,
  [actions.FETCH_REQUEST_USER_SUBSCRIPTIONS_ERROR]: fetchRequestUserSubscriptionsError,
  [actions.FETCH_REQUEST_USER_SUBSCRIPTIONS_SUCCESS]: fetchRequestUserSubscriptionsSuccess,
  [actions.SUBSCRIBE_TO_REQUEST_DATASET]: subscribeToRequestDataset,
  [actions.SUBSCRIBE_TO_REQUEST_DATASET_ERROR]: subscribeToRequestDatasetError,
  [actions.SUBSCRIBE_TO_REQUEST_DATASET_SUCCESS]: subscribeToRequestDatasetSuccess,
};
